import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';
import { TranslateService } from 'src/app/Services/translate.service';
import { Router } from '@angular/router';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
import { LoginService } from '../../Services/login.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  selected = 'ENG';
  languages: any;
  constructor(public _global: GlobalService, public dialog: MatDialog, private loginservice: LoginService, public translate: TranslateService,private router:Router,private quoteService:QuoteService) { }
  openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
        panelClass: 'loginpopupbox'
    });
  }


  ngOnInit() {  
    sessionStorage.clear();
    
    if(this._global.selectLang == "en"){
      this.selected = 'ENG'; 
    } 
    else{
      this.selected = 'VET'; 
    }
    
    if (sessionStorage.getItem('langFlag') != undefined && sessionStorage.getItem('langFlag') == 'true') {
      this.loginservice.checkedvalues(null).subscribe((data: any) => {
        if (data.responseBody.Detail != null) {
          this.languages = data.responseBody.Detail;
          sessionStorage.removeItem('langFlag');
        }
      });
    } 
               //to unlock the QQ
               
               var unlock = sessionStorage.getItem('LOCK');
               if(unlock =="L"){
                 
                 var userName =sessionStorage.getItem('userName');
                 this.quoteService.unlockQuotedetails(userName).subscribe((data:any)=>{
                   
                   console.log(data);
                 })
               }
             //END
  }
  contactclick(){
    this.router.navigate(["/contactUs"])
  }
  onChange(eve) {

    if (eve.value == "VET") {
      this._global.pageDir = "ltr"
      this._global.selectLang = "vn";
      this._global.showArabic = true;
    } else if (eve.value == "ENG") {
      this._global.pageDir = "ltr"
      this._global.selectLang = "en";
      this._global.showArabic = false;
    }
    else {
      this._global.pageDir = "ltr"
      this._global.selectLang = "vn";
      this._global.showArabic = false;
    }
    this.translate.use(this._global.selectLang).then((data) => {
      this._global.loadPageContent(window.location.href);
      this._global.menuContent = this.translate.data["menu"];
      this._global.commonContent = this.translate.data["commonmessage"];
      this._global.headerEmitter.emit("language change");
    });
  }


}
